var BlockView = require('views/block/base-block-view');
var QuestionView = require('views/block/assessment/question-view');
var QuestionProgressView = require('views/block/assessment/question-progress-view');
var QuestionCollectionView = require('views/block/assessment/question-collection-view');
var AssessmentService = require('services/assessment-service');
var EvaluationService = require('services/evaluation-service');
import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');
var FeedbackService = require('services/feedback-service');
import { SessionStorageService } from 'services/web-storage-service';
var ProgressService = require('services/progress-service');
var ContentProvider = require('services/content-provider');


const { Enter, ArrowUp, ArrowDown, ArrowLeft, ArrowRight, Space } = keys;

var AssessmentView = BlockView.extend({
  regions: {
    'question': '.questionContainer'
  },
  initialize: function(_options) {
    BlockView.prototype.initialize.apply(this, arguments);
    this.model.set('local', EF.options.local);
    this.requestingAnswer = false;
  },
  load: function() {
    var self = this;
    if(EvaluationService.shouldSkip()) {
      this.readyToGo();
    }
    this.model.set('question_index', 0);
    if(!this.model.get('question_separator')) {
      this.model.set('question_separator', '/');
    }

    if(this.model.get('redirect') && this.model.get('assessment_slug')) {
      this.$el.hide();
    }

    var startAssessment = function() {
      if(self.model.get('split_questions')) {
        self.assessment.filterQuestions(self.model.get('split_questions'), self.model.get('split_index_start'));
      }

      self.assessment.get('questions').each(function(q) {
        q.set('question_template', self.model.get('question_template'));
        if(self.model.get('question_input')) {
          q.set(self.model.get('question_input'), true);
        }
        if(q.get('media')) {
          q.set('image_path', q.get('media'));
        }
        if(self.model.get('badge_class')) {
          _.each(q.get('answers'), function(a) {
            a.badge_class = self.model.get('badge_class');
          });
        }
        if(self.model.get('badge_type')) {
          if(self.model.get('badge_type') === 'numbers') {
            let badge = 1;
            _.each(q.get('answers'), function(a) {
              a.badge_value = badge;
              badge++;
            });
          } else if(self.model.get('badge_type') === 'letters') {
            let badge = 65;
            _.each(q.get('answers'), function(a) {
              a.badge_value = String.fromCharCode(badge);
              badge++;
            });
          }
        }

        if(self.assessment.get('local')) {
          q.set('text', LocaleService.t(q.get('text')));
          _.each(q.get('answers'), function(a) {
            a.text = LocaleService.t(a.text);
          });
        }

        if(self.assessment.get('subtext')) {
          q.set('subtext', LocaleService.t(self.assessment.get('subtext')));
        }

        if(self.model.get('submit_button')) {
          q.set('submit_button', self.model.get('submit_button'));
        }
      });
      self.model.set('total_questions', self.assessment.get('questions').length);
      self[self.model.get('template')]();
    };

    if(this.model.get('redirect') && this.model.get('assessment_slug')) {
      // move along
      return;

    } else if(this.model.get('assessment_slug')) {
      this.assessment = new EF.Models.Assessments.Assessment();
      ContentProvider.AssessmentService.loadCourseAssessment(this).then(startAssessment);
    } else {
      this.assessment = new EF.Models.Assessments.Assessment();
      this.assessment.set('questions', new EF.Collections.Assessments.QuestionsCollection(this.model.get('questions')));
      this.assessment.get('questions').each(question => question.set('id', question.get('id').toString()));
      this.assessment.set('attempt', new EF.Models.Assessments.Attempt(1, { assessment: this.assessment }));
      this.assessment.set('local', true);
      this.assessment.set('passing_grade', this.model.get('passing_grade'));
      this.assessment.set('subtext', this.model.get('subtext'));
      startAssessment();
    }
    //need to control fad speed of questions
    this.fadeSpeed = parseInt(this.model.get('fade_speed'), 10) || 0;

  },

  play: function() {
    if(this.model.get('redirect') && this.model.get('assessment_slug')) {
      this.handleAssessmentRedirect();
    }
  },
  // Handles assessments using the assessment system's interface
  handleAssessmentRedirect: function() {
    if(EF.enrollment.get('demoMode') === 'preview') {
      this.readyToGo();
      Chaplin.mediator.publish('page:navigate', 'forward');
    }
    if(EF.options.local) {
      if(AssessmentService.userHasCompletedAssessment(this.model.get('assessment_slug'))) {
        this.readyToGo();
        Chaplin.mediator.publish('page:navigate', 'forward');
      } else {
        this.delegate('click', '[data-local-action]', function(e) {
          e.preventDefault();
          var passed = (e.target.attributes['data-local-action'].value === 'pass');
          ProgressService.saveLocalActivityProgress({
            'attempt': 1,
            'enrollment_id': EF.enrollment.get('id'),
            'grade': passed ? 100 : 10,
            'passed': passed,
            'slug': this.model.get('assessment_slug')
          }, EF.module.get('key')).done(() => ContentProvider.AssessmentService.refreshActivityProgress());
          this.readyToGo();
          Chaplin.mediator.publish('page:navigate', 'forward');
        });
      }
    } else {

      var queryParams = SessionStorageService.getItem('queryParams') || {};
      EvaluationService.refreshResponseSet(this.model.get('assessment_slug')).then(() => {
        if(AssessmentService.userHasCompletedAssessment(this.model.get('assessment_slug')) || queryParams.assessmentTaken) {
          this.readyToGo();
          Chaplin.mediator.publish('page:navigate', 'forward');
        }
        else {
          this.$el.show();
          setTimeout(() => { ContentProvider.AssessmentService.triggerAssessment(this); }, 2000);
        }
      });
    }
  },
  all_at_once: function() {
    var questionCollectionView = new QuestionCollectionView({
      region: 'question',
      collection: this.assessment.get('questions')
    });
    this.subview('questions', questionCollectionView);

    var self = this;
    this.assessment.get('questions').each(function(q) {
      self[self.model.get('question_template')](q);
    });
  },
  one_at_a_time: function() {
    var questionProgressView = new QuestionProgressView({
      model: this.model,
      region: 'question'
    });
    this.subview('question_progress', questionProgressView);

    var currentQuestion = this.assessment.get('questions').at(this.model.get('question_index'));
    var questionView = new QuestionView({
      model: currentQuestion,
      region: 'question'
    });
    this.subview('question', questionView);

    this.$('#questionContainer').fadeIn(this.fadeSpeed,
      function() {
        this.$('#questionContainer').css('pointer-events', 'auto');
      }.bind(this));

    this[this.model.get('question_template')](currentQuestion);
    Chaplin.mediator.publish('assessment:question:loaded');
  },
  fill_in_the_blank: function(question) {
    var self = this;
    this.delegate('change', '#question_' + question.get('id'), function(e) {
      self.addAnswer(this.$(e.currentTarget));
    });
  },
  multiple_choice: function(question) {
    const self = this;

    const $button = this.$('#button_' + question.get('id'));
    const response_type = question.get('response_type') || 'single_selection';
    if(response_type === 'multiple_selection' || !!question.get('submit_button')) {
      this.delegate('click', '#button_' + question.get('id'), function(e) {
        const $answerElement =  this.$(e.currentTarget).siblings(`#question_${question.get('id')}`).find('.assessment_answer');
        const $activeElements = $answerElement.filter('.active');
        const $selectedAnswers = $activeElements.find('input');

        self.addAnswer($selectedAnswers, $activeElements);
        $('.inline-feedback').children().removeAttr('tabindex');

        // disables the question answers and button after submitting answer
        if(!self.model.get('allow_answer_change')) {
          [...$answerElement].forEach(el => $(el).attr('disabled', true));
          $button.attr('disabled', true);
        }
      });
      this.delegate('click', '#question_' + question.get('id') + ' .assessment_answer', e => {
        const $radio = $(e.currentTarget);
        $radio.toggleClass('active');

        const $activeElements = $(e.currentTarget).parent().find('.assessment_answer.active');
        $button.attr('disabled', !$activeElements.length);
      });
    } else {
      const $answerElements = $('#question_' + question.get('id') + ' .assessment_answer');

      this.delegate('click', '#question_' + question.get('id') + ' .assessment_answer', e => {
        const $radio = $(e.currentTarget);

        $radio.siblings().attr('aria-checked', false);
        $radio.siblings().removeClass('active');
        $radio.attr('aria-checked', true);
        $radio.addClass('active');
        if(self.requestingAnswer && !EF.options.local) {
          e.preventDefault();
          $radio.find('input').prop('checked',false);
          return false;
        }

        self.addAnswer(this.$(e.currentTarget).find('input'), this.$(e.currentTarget));
        $('.inline-feedback').children().removeAttr('tabindex');

        // disables the question answers
        if(!self.model.get('allow_answer_change')) {
          [...$answerElements].forEach(el => $(el).attr('disabled', true));
        }
      });
    }

    // handle tab and enter events
    this.delegate('keydown', '#question_' + question.get('id') + ' .assessment_answer', function(e) {
      KeybindingService.with(e).bind(
        [Enter, Space], () => {
          e.preventDefault();
          this.$(e.currentTarget).click();
          $('.inline-feedback').children().removeAttr('tabindex');
        },
        [ArrowLeft, ArrowUp], () => {
          this.$(e.currentTarget)
          .prev('.assessment_answer')
          .focus();
        },
        [ArrowRight, ArrowDown], () => {
          this.$(e.currentTarget)
            .next('.assessment_answer')
            .focus();
        }
      );
    });
  },
  addAnswer: function($selectedAnswers, $activeElements) {
    if(!EF.options.local && !this.assessment.get('local')) {
      this.requestingAnswer = true;
    }
    const self = this;
    const $loader = self.$el.find('.questionContainer .loader');

    $loader.addClass('show-when-loading');

    $activeElements = $activeElements || $selectedAnswers;
    const questionId = $selectedAnswers.attr('data-question-id');
    const answersId = [...$selectedAnswers].map(selected => $(selected).val());

    this.assessment.get('attempt').answerQuestion(questionId, answersId);

    if(this.assessment.get('local')) {
      const question = this.assessment.get('questions').find({ id: questionId });
      let correct;
      if(question.get('correct_answer')) {
        correct = question.get('correct_answer').toString() === answersId.toString();
      } else if(question.get('correct_answers')) {
        correct = question.get('correct_answers').includes(answersId.toString());
      }
      const feedback = this.model.get('split_questions') ? this.model.get('post_answer_feedback') : question.get('feedback');

      if(this.model.get('custom_responses')) {
        feedback.customResponses = this.model.get('custom_responses');
      }
      const feedbackState = correct ? 'correct' : 'incorrect';
      const possibleStates = [ 'correct', 'incorrect' ];

      FeedbackService.renderFeedbackWithElementState(feedback, $activeElements.first(), feedbackState, possibleStates, {
          completed: function() {
            self.customFeedback(feedback, $activeElements.first());
            self.checkComplete(correct);
            $loader.removeClass('show-when-loading');
          },
          noFeedback: _.bind(this.checkComplete, this)
        });
    } else if(this.model.get('split_questions')) {

        this.assessment.get('attempt').once('assessment:saved', (results) => {
          results.total = self.calculateTotalQuestions();
          results.correct = 0;  // If the assessment is not complete, default this to 0 so that the score page doesn't look completely broken
          SessionStorageService.setItem('assessmentResults', results);
          const possibleStates = [ 'correct', 'incorrect' ];
          const questionId = parseInt(this.assessment.get('attempt').get('current_question_id'));
          const feedback = this.model.get('post_answer_feedback');
          results.state = ContentProvider.AssessmentService.isAttemptCorrect(results, questionId) ? 'correct' : 'incorrect';
          if(feedback) {
            FeedbackService.renderFeedbackWithElementState(feedback, $activeElements.first(), results.state, possibleStates, {
              completed: function() {
                if( self.model.get('custom_responses') ) {
                  feedback.customResponses = self.model.get('custom_responses');
                  self.customFeedback(feedback, $activeElements.first());
                }
                self.checkComplete();
                $loader.removeClass('show-when-loading');
              },
              noFeedback: _.bind(this.checkComplete, this)
            });
          }

        });
        this.assessment.get('attempt').save();
    } else {
      this.checkComplete();
    }
  },
  calculateCorrectQuestions: function(totalQuestions, percentage) {
    return Math.round((percentage * totalQuestions) / 100);
  },
  calculateTotalQuestions: function() {
    return this.model.get('split_questions') ? this.assessment.get('original_questions').length : this.assessment.get('questions').length;
  },
  checkComplete: function(correct) {
    var self = this;
    if(ContentProvider.AssessmentService.isAttemptComplete(this.assessment.get('attempt'))) {
      this.assessment.get('attempt').once('assessment:saved', function(results) {
        if(this.assessment.get('attempt').isFinished()) {
          results.total = self.calculateTotalQuestions();
          results.correct = self.calculateCorrectQuestions(results.total, results.grade);
        }
        SessionStorageService.setItem('assessmentResults', results);
        Chaplin.mediator.publish('assessment:complete');
        //TODO: not sure we should wait for assessment save to move on?  need to know the results...

        var tryContinue = function() {
          if(self.model.get('assessment_slug')) {
            ContentProvider.AssessmentService.refreshActivityProgress();
          }
          if(self.model.get('must_pass')) {
            if(results.state === 'passed') {
              self.readyToGo();
            }
          } else {
            self.readyToGo();
          }
        };

        var possibleStates = ['passed', 'failed', 'perfect'];
        var resultsState = results.state;

        if(resultsState === 'passed' && results.grade === 100) {
          resultsState = 'perfect';
        }

        FeedbackService.renderFeedbackWithElementState(self.model.get('post_quiz_feedback'), self.$el, resultsState, possibleStates, {
          completed: tryContinue,
          noFeedback: tryContinue
        });
        self.requestingAnswer = false;
      });

      if(EF.enrollment.get('demoMode') !== 'preview') {
        if(!self.assessment.get('local')) {
          if(!self.model.get('allow_answer_change')) {
            self.$el.find('.question_block .assessment_answer').prop('disabled', true);
          }
        }
        if(!this.model.get('split_questions')) {
          this.assessment.get('attempt').save();
        }
        self.requestingAnswer = false;
      } else {
        Chaplin.mediator.publish('assessment:complete');
        FeedbackService.renderFeedbackWithElementState(self.model.get('post_quiz_feedback'), self.$el, 'passed', ['passed'], {
          completed: self.readyToGo,
          noFeedback: self.readyToGo
        });
        self.requestingAnswer = false;
      }

    } else if(this.assessment.get('attempt').isSubSetComplete()) {
      self.readyToGo();
      if(EF.enrollment.get('demoMode') !== 'preview') {
        if(!self.assessment.get('local')) {
          if(!self.model.get('allow_answer_change')) {
            self.$el.find('.question_block .assessment_answer').prop('disabled', true);
          }
        }
      }
      self.requestingAnswer = false;
    } else if(this.model.get('template') === 'one_at_a_time') {
      if((this.model.get('require_retry') && correct) || !this.model.get('require_retry')) {
        this.model.set('question_index', this.model.get('question_index') + 1);

        if(this.model.get('question_index') < this.assessment.get('questions').length) {
          var questionContainer = this.$('#questionContainer');
          questionContainer.css('pointer-events', 'none');
          questionContainer.fadeOut(this.fadeSpeed, _.bind(this.one_at_a_time, this));
        } else {
          throw new Error("assessment isn't complete, but there are no more questions");
        }
        self.requestingAnswer = false;
      }
    }
  },
  customFeedback: function(feedback, answerElement) {
    setTimeout(() => {
      const $feedbackText = this.pageView.$el.find('.assessment-feedback-text .description');
      const $questionText = this.pageView.$el.find('.questionContainer');
      const defaultText = $feedbackText.text();
      const questionIndex = this.model.get('question_index');
      const answerIndex = answerElement.index();

      if(feedback.customResponses && feedback.customResponses[questionIndex][answerIndex]) {
        $feedbackText.html(LocaleService.t(feedback.customResponses[questionIndex][answerIndex]));
        if(this.model.get('hide_question_after_answered')) {
          $questionText.hide();
        }
      } else {
        $feedbackText.html(defaultText);
      }
    }, 0);
  }
});

module.exports = AssessmentView;
